import { application } from "./application"

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)
